<template>
  <div>
    <titulo-periodo-letivo @cadastrar="irPara"/>
    <tabela :items="items" @editar="irPara" @excluir="excluir" @alterar-ordenacao="novaOrdenacao"/>
    <paginacao v-model="paginacao" :total="paginacao.total" @input="getAnosLetivos" />
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import Permisoes from '@/components/mixins/permissoes';
import breadcrumb from '@/common/utils/breadcrumb';
import mensagem from '@/common/utils/mensagem';
import rotas from '@/common/utils/rotas';

// Services:
import AnoLetivoService from '@/common/services/anoLetivo/ano-letivo.service.js';

// Components:
import Tabela from './components/Tabela.vue';
import TituloPeriodoLetivo from '@/views/periodos-letivos/periodo-letivo/components/TituloPeriodoLetivo'
import Paginacao from '@/components/paginacao/Paginacao';

export default {
  mixins: [Permisoes],
  components: {
    Tabela,
    TituloPeriodoLetivo,
    Paginacao
  },
  data() {
    return {
      items: [],
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      },
      campoOrdenado: null,
      ordem: false,
    };
  },
  mounted() {
    breadcrumb.definir(this.$store, [
      { titulo: this.$t('ACADEMICO_HOME.PAINEL_ACADEMICO') },
      { titulo: this.$t('ACADEMICO.ESTRUTURA_CEJ') },
      { titulo: this.$t('ACADEMICO.PERIODO_LETIVO') },
    ]);
    this.getAnosLetivos();
  },
  methods: {
    getAnosLetivos() {
      this.$store.dispatch(START_LOADING);
      AnoLetivoService.obterPeriodoLetivo(this.paginacao, this.campoOrdenado, this.ordem)
        .then(({ data }) => {
          this.items = data.itens;
          this.paginacao.total = data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    excluir(item) {
      mensagem
        .confirmacao(null, this.$t('Deseja excluir período letivo?'))
        .then(async (result) => {
          if (result.value) {
            this.$store.dispatch(START_LOADING);
            AnoLetivoService.excluir(item.id)
              .then(() => {
                this.getAnosLetivos();
                mensagem.sucesso(
                  this.$t('GERAL.SUCESSO'),
                  this.$t('Período excluído com sucesso')
                );
              })
              .catch((err) => {
                mensagem.showErrors(err);
              })
              .finally(() => {
                this.$store.dispatch(STOP_LOADING);
              });
          }
        });
    },
    irPara(rota, id) {
      rotas.irPara(rota, id);
    },
    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = !ordem;
      this.getAnosLetivos(); 
    },
  },
};
</script>
